"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.singleton = singleton;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/prefer-function-type -- needed
function singleton(Constructor) {
  var _Singleton;
  return _Singleton = class Singleton extends Constructor {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- needed
    constructor(...args) {
      if (Singleton.instance instanceof Singleton) {
        // eslint-disable-next-line no-constructor-return -- needed
        return Singleton.instance;
      }

      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument -- needed
      super(...args);
      Singleton.instance = this;

      // eslint-disable-next-line no-constructor-return -- needed
      return this;
    }
  }, (0, _defineProperty2.default)(_Singleton, "instance", void 0), _Singleton;
}
//# sourceMappingURL=singleton.js.map